
  import SsrCarousel from 'vue-ssr-carousel';
  import studentStories from '~/data/studentStories.json';
  
  export default {
    name: 'StudentStoriesFeed',
    components: { SsrCarousel },
    props:{},
    data() {
      return {
        stories: studentStories.pages.nodes.slice(0, 10)
      }
    },
  };
  